<template>
  <v-layout>
    <div class="col-12">
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('competitions') }}</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
              v-model="activeTab"
              align-with-title
          >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab>{{ $t('active') }}</v-tab>
            <v-tab>{{ $t('completed') }}</v-tab>
            <v-tab>{{ $t('deleted') }}</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <competition-table status="Active" v-if="activeTab === 0" />
        </v-tab-item>
        <v-tab-item>
          <competition-table status="Completed" v-if="activeTab === 1" />
        </v-tab-item>
        <v-tab-item>
          <competition-table status="Deleted" v-if="activeTab === 2" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-layout>
</template>
<script>
import CompetitionTable from "@/views/CompetitionTable.vue";

export default {
  name: "Competitions",
  components: {CompetitionTable},

  data: () => ({
    activeTab: 0,
    tabs: ['Active', 'Completed', 'Deleted']
  }),
};
</script>
